class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // 初期設定
    gsap.set(".js-mv", { x: "-100%" });
    gsap.set(".js-mv-bg", { x: "-100%" });
    gsap.set(".js-mv-icon li", { scale: 0.9, opacity: 0 });
    gsap.set(".js-mv-copy", { x: "-100%" });
    gsap.set(".js-mv-news", { opacity: 0 });

    // アニメーションの実行
    gsap.timeline()
      .to(".js-mv", { x: "0%", duration: 0.3, ease: "power2.out" })
      .to(".js-mv-bg", { x: "0%", duration: 1, ease: "power2.out" }, "-=0.5")
      .to(".js-mv-icon li", { 
        scale: 1, 
        opacity: 1, 
        duration: 0.3, 
        ease: "back.out(1.7)", 
        stagger: 0.2 // 順番に拡大しながら表示 
      })
      .to(".js-mv-copy", { x: "0%", duration: 0.3, ease: "power2.out" }) // 左から右にスライドイン
      .to(".js-mv-news", { opacity: 1, duration: 0.5, ease: "power2.out" }); // ゆっくり表示

  }
}
